import { RefObject, useRef, useState } from "react";
import SearchInput from "./SearchInput";
import { useNavigate } from "react-router";

const SearchIcon = ({ color = "#8F9098" }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" stroke={color} strokeWidth="2" />
    <path d="M20 20l-3.5-3.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// const FilterIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="17" height="11" viewBox="0 0 17 11" fill="none">
//     <path d="M7.52875 11C7.31625 11 7.13817 10.9281 6.9945 10.7843C6.85067 10.6404 6.77875 10.4622 6.77875 10.2498C6.77875 10.0371 6.85067 9.859 6.9945 9.7155C7.13817 9.57183 7.31625 9.5 7.52875 9.5H9.4615C9.674 9.5 9.85217 9.57192 9.996 9.71575C10.1397 9.85958 10.2115 10.0378 10.2115 10.2503C10.2115 10.4629 10.1397 10.641 9.996 10.7845C9.85217 10.9282 9.674 11 9.4615 11H7.52875ZM3.65375 6.25C3.44125 6.25 3.26317 6.17808 3.1195 6.03425C2.97583 5.89042 2.904 5.71225 2.904 5.49975C2.904 5.28708 2.97583 5.109 3.1195 4.9655C3.26317 4.82183 3.44125 4.75 3.65375 4.75H13.3365C13.549 4.75 13.7272 4.82192 13.871 4.96575C14.0147 5.10958 14.0865 5.28775 14.0865 5.50025C14.0865 5.71292 14.0147 5.891 13.871 6.0345C13.7272 6.17817 13.549 6.25 13.3365 6.25H3.65375ZM0.75 1.5C0.5375 1.5 0.359417 1.42808 0.21575 1.28425C0.0719168 1.14042 0 0.96225 0 0.74975C0 0.537083 0.0719168 0.359 0.21575 0.2155C0.359417 0.0718332 0.5375 0 0.75 0H16.25C16.4625 0 16.6406 0.0719168 16.7843 0.21575C16.9281 0.359583 17 0.53775 17 0.75025C17 0.962917 16.9281 1.141 16.7843 1.2845C16.6406 1.42817 16.4625 1.5 16.25 1.5H0.75Z" fill="#F15A29" />
//   </svg>
// );

const BackIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M15 5l-7 7 7 7" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


interface Props {
  searchValue: string;
  onSearchChange: (v: string) => void;
  searchPlaceholder?: string;
  filterOpen?: boolean;
  onToggleFilter?: () => void;
  filterBtnRef?: RefObject<HTMLButtonElement | null>;
}


const HomeHeader = ({ searchValue, onSearchChange, searchPlaceholder = "Search Dish / Enter Menu Code", filterOpen, onToggleFilter, filterBtnRef }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="sticky top-0 z-30 bg-white pt-3 pb-3 shadow-[0_4px_20px_rgba(0,0,0,0.12)]">
        <div className="flex items-center gap-2 px-3 h-12">
          {!searchOpen && (
            <div className="shrink-0 flex items-center">
              <img
                src="/mobile-assets/eagle.png"
                alt="FML"
                width={48}
                height={48}
                className="h-12 w-auto"
              />
            </div>
          )}

          {searchOpen ? (
            <SearchInput
              ref={inputRef}
              type="text"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder}
              containerClassName="flex-1 min-w-0"
              className="text-[12px]"
              showClear
              onClear={() => {
                onSearchChange("");
                setSearchOpen(false);
              }}
            />
          ) : (
            <div className="flex-1" />
          )}

          {!searchOpen && (
            <button
              type="button"
              aria-label="Open search"
              onClick={() => {
                setSearchOpen(true);
                setTimeout(() => inputRef.current?.focus(), 0);
              }}
              className="shrink-0 w-11 h-11 rounded-[10px] flex items-center justify-center bg-white border border-[#E8E9F1]"
            >
              <SearchIcon color="#F15A29" />
            </button>
          )}

          {/* {onToggleFilter && (
            <button
              ref={filterBtnRef}
              type="button"
              aria-label="Filter"
              aria-expanded={filterOpen}
              onClick={onToggleFilter}
              className="shrink-0 w-11 h-11 rounded-[10px] flex items-center justify-center bg-white border border-[#E8E9F1]"
            >
              <FilterIcon />
            </button>
          )} */}
        </div>
      </div>
    </>
  );
};

export default HomeHeader;
